/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Focus_AnalysisInputs */

const en_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus performance insights`)
};

const ar_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليلات أداء التركيز`)
};

const de_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus Leistung Einblicke`)
};

const es_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información detallada sobre el rendimiento de concentración`)
};

const fr_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques personnalisées de concentration`)
};

const it_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi prestazioni di concentrazione`)
};

const ja_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中データ分析`)
};

const ko_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 성능 인사이트`)
};

const pt_br_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insights sobre o desempenho de foco`)
};

const ru_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аналитика фокусировки`)
};

const th_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อมูลเชิงลึกประสิทธิภาพการโฟกัส`)
};

const tr_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performans içgörülerine odaklan`)
};

const zh_cn_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注数据分析`)
};

const zh_tw_focus_analysis = /** @type {(inputs: Focus_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注數據分析`)
};

/**
* | output |
* | --- |
* | "Focus performance insights" |
*
* @param {Focus_AnalysisInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const focus_analysis = /** @type {((inputs?: Focus_AnalysisInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focus_AnalysisInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focus_analysis(inputs)
	if (locale === "ar") return ar_focus_analysis(inputs)
	if (locale === "de") return de_focus_analysis(inputs)
	if (locale === "es") return es_focus_analysis(inputs)
	if (locale === "fr") return fr_focus_analysis(inputs)
	if (locale === "it") return it_focus_analysis(inputs)
	if (locale === "ja") return ja_focus_analysis(inputs)
	if (locale === "ko") return ko_focus_analysis(inputs)
	if (locale === "pt_br") return pt_br_focus_analysis(inputs)
	if (locale === "ru") return ru_focus_analysis(inputs)
	if (locale === "th") return th_focus_analysis(inputs)
	if (locale === "tr") return tr_focus_analysis(inputs)
	if (locale === "zh_cn") return zh_cn_focus_analysis(inputs)
	return zh_tw_focus_analysis(inputs)
});